module.exports = __webpack_public_path__ + "media/images/flags/lv-6f6eaa7b24c0a8bb5714621307a4fda1.svg";